export default function inputFile() {
    if (document.querySelector(".input-file")) {
        let fileName = document.querySelector(".input-file");
        let fileInput = document.querySelector(".input input");

        fileInput.addEventListener("change", ({target,}) => {
            if (target.files[0].type === "application/pdf") {
                fileName.textContent = target.files[0].name;
                return;
            }

            target.value = "";
        });
    }
}
